var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClothRecolorNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 1280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 1280,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M640,224c264.67,0,480,186.62,480,416v1.71a38.64,38.64,0,0,1-11.9,28.13,41.19,41.19,0,0,1-28.83,11.77,43.84,43.84,0,0,1-9.58-1.08A356.3,356.3,0,0,0,992,672c-176.45,0-320,129.2-320,288a263.27,263.27,0,0,0,5.2,52,36.78,36.78,0,0,1-7.48,31.07,34,34,0,0,1-27,12.88H640c-264.67,0-480-186.62-480-416S375.33,224,640,224m0-96C321.88,128,64,357.23,64,640s257.88,512,576,512h3.2c83.43-.4,144.64-77.19,128.1-159a166.18,166.18,0,0,1-3.3-33c0-106,100.29-192,224-192a260,260,0,0,1,56.73,6.21,139.72,139.72,0,0,0,30.54,3.4c73.26,0,136.37-58.54,136.72-135.45,0-.72,0-1.44,0-2.16,0-282.77-257.88-512-576-512Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352,480a96,96,0,1,0,96,96,96,96,0,0,0-96-96Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M576,320a96,96,0,1,0,96,96,96,96,0,0,0-96-96Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M864,384a96,96,0,1,0,96,96,96,96,0,0,0-96-96Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothRecolorNormal);
export default __webpack_public_path__ + "static/media/clothRecolor_normal.d317848d03c7b2005c52de2e8aed6f7a.svg";
export { ForwardRef as ReactComponent };